/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Deleted_SuccessInputs */

const en_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Issue deleted successfully`)
};

const fr_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incident supprime avec succes`)
};

const de_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem erfolgreich gelöscht`)
};

const it_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema eliminato con successo`)
};

const ru_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблема успешно удалена.`)
};

const es_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema eliminado exitosamente`)
};

const zh_cn2_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`问题已成功删除`)
};

const ja_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題は正常に削除されました`)
};

const hi_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समस्या सफलतापूर्वक हटा दी गई`)
};

const pt_pt2_manual_qc_deleted_success = /** @type {(inputs: Manual_Qc_Deleted_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problema resolvido com sucesso`)
};

/**
* | output |
* | --- |
* | "Issue deleted successfully" |
*
* @param {Manual_Qc_Deleted_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_deleted_success = /** @type {((inputs?: Manual_Qc_Deleted_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Deleted_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_deleted_success(inputs)
	if (locale === "de") return de_manual_qc_deleted_success(inputs)
	if (locale === "it") return it_manual_qc_deleted_success(inputs)
	if (locale === "ru") return ru_manual_qc_deleted_success(inputs)
	if (locale === "es") return es_manual_qc_deleted_success(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_deleted_success(inputs)
	if (locale === "ja") return ja_manual_qc_deleted_success(inputs)
	if (locale === "hi") return hi_manual_qc_deleted_success(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_deleted_success(inputs)
	return en_manual_qc_deleted_success(inputs)
});